/**
 * Service worker helper.
 *
 * Boilerplate ito ng Create React App -- hindi sinulat ng team ninyo.
 * Sa orihinal, may ~140 linya: register(), registerValidSW(),
 * checkValidServiceWorker(), at isLocalhost. Wala ni isa sa mga iyon ang
 * tinatawag kahit saan sa app. `unregister()` lang ang aktwal na ginagamit,
 * sa src/index.js.
 *
 * BAKIT KAILANGAN PA RIN ITO:
 * Kung nakapag-register na ng service worker ang isang browser dati (mula sa
 * lumang deploy), mananatili iyon doon habambuhay hangga't hindi na-unregister.
 * Kaya kahit hindi na kayo nagre-register, dapat patuloy na tumatakbo ang
 * unregister() -- iyon ang naglilinis sa mga naiwang service worker sa
 * browser ng staff ninyo.
 *
 * BAKIT HINDI IBINALIK ANG register():
 * Admin panel ito, hindi public website. Ang service worker ay nagse-serve ng
 * cached na bersyon muna bago ang bago. Sa internal na tool, ibig sabihin niyan:
 * magde-deploy kayo ng bugfix, tapos "hindi pa rin ayos" ang sasabihin ng staff
 * dahil luma pa rin ang naka-cache sa kanila. Hindi sulit ang offline support
 * kapalit ng ganoong sakit ng ulo.
 *
 * Kung kailanganin ninyo talaga, nasa Create React App docs ang buong bersyon:
 * https://create-react-app.dev/docs/making-a-progressive-web-app/
 */
export function unregister() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    // Walang .catch dati. Kapag pumalya ito (hal. blocked ang SW sa private
    // browsing), lumalabas ang "unhandled promise rejection" sa console
    // tuwing magbubukas ng app.
    .catch((error) => {
      console.error('Service worker unregister failed:', error);
    });
}